import {
  type ActionTree,
  type GetterTree,
  type Module,
  type MutationTree,
} from "vuex";
import { type RootState } from "../../root/store/state";
import { type TicketListState } from "./ticket-list-state";

const state: TicketListState = {
  sortBy: "jsUpdatedOn",
  assignedToMe: false,
  clientId: [] as string[],
  contactId: [] as string[],
  descending: false,
  location: [] as string[],
  page: 1,
  filterView: null,
  viewScheduler: false,
  fillingTickets: true,
  filterViewPayload: {},
  fetchTicketListOnChange: true,
  draggedTicket: null,
  fillingTicketsByTick: false,
  ticketIdsOfDefaultView: [] as string[],
  ticketsFoundInIndexedDB: true,
  preventTicketUpdateToIndexedDb: true,
  recountFilters: false,
  areFilterViewResultsLoading: false,
};

const getters: GetterTree<TicketListState, RootState> = {
  getContactId(state): string[] {
    return state.contactId;
  },

  getLocation(state): string[] {
    return state.location;
  },

  areFilterViewResultsLoading(state): boolean {
    return state.areFilterViewResultsLoading;
  },
};

const actions: ActionTree<TicketListState, RootState> = {};

const mutations: MutationTree<TicketListState> = {
  Set_FilterViewResultsLoadingState(state, value: boolean) {
    state.areFilterViewResultsLoading = value;
  },
};

const namespaced: boolean = true;

export const ticketListModule: Module<TicketListState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
